<!-- 買う・使う一覧のサムネイル画像表示 -->
<template>
  <div class="book-index-content-left">
    <img class="list-item__thumbnail_book" :src="imageUrl" />
  </div>
</template>

<script>
export default {
  name: "TheCouponThumbnail",
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.book-index-content-left {
  float: left;
  width: 85px;
  max-width: 23vw;
}
.list-item__thumbnail_book {
  width: 65px;
  max-width: 23vw;
  background-size: cover;
}
</style>
